module.exports = __webpack_public_path__ + "static/media/sarva.1134dfca.png";